import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionFlow } from '../components/SolutionFlow';
import { FeatureCards } from '../components/FeatureCards';
import { DeviceSupport } from '../components/DeviceSupport';
import { PrivacySection } from '../components/PrivacySection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-teal-100 selection:text-teal-900" data-id="element-175">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-100" data-id="element-176">
        <div className="container mx-auto px-4 h-16 flex items-center justify-between" data-id="element-177">
          <div className="flex items-center" data-id="element-178">
            <img src="https://cdn.magicpatterns.com/uploads/8FSu8CQTWvoMhpfjhng9JD/Vytaniq_Brandd_Logo.png" alt="Vytaniq" className="h-10" data-id="element-179" />
          </div>
          <a href="#waitlist" className="text-sm font-medium text-slate-600 hover:text-teal-600 transition-colors" data-id="element-180">
            Join Waitlist
          </a>
        </div>
      </nav>

      <main data-id="element-181">
        <Hero data-id="element-182" />
        <ProblemSection data-id="element-183" />
        <SolutionFlow data-id="element-184" />
        <FeatureCards data-id="element-185" />
        <DeviceSupport data-id="element-186" />
        <PrivacySection data-id="element-187" />
      </main>

      <div id="waitlist" data-id="element-188">
        <Footer data-id="element-189" />
      </div>
    </div>;
}